import { useRef, useState } from 'react'
import { Form, Field } from 'react-final-form'
import { Row, Col, Card, CardBody, CardHeader, FormGroup, CardTitle, CardFooter } from 'reactstrap'
import { ReduxFormSwitch, renderInput } from '../general/FormInputs'
import SaveButton from '../general/SaveButton'
import OrgPermissionsGrid from '../permissions/OrgPermissionsGrid'
import brandit_rails from '../../api/brandit_rails'

const OrgRoleCreate = props => {
  const permissionsRef = useRef({})

  const onSubmit = async values => {
    // transform the permissions object into an array of object attributes for ActiveRecord
    const orgRolePermissionAttributes = Object.keys(permissionsRef.current).map(groupId => {
      const permission = permissionsRef.current[groupId]
      // only include new crud value in attributes if it is not undefined
      const newPermission = { org_permission_group_id: groupId }
      if (permission.c !== undefined) newPermission.c = permission.c
      if (permission.r !== undefined) newPermission.r = permission.r
      if (permission.u !== undefined) newPermission.u = permission.u
      if (permission.d !== undefined) newPermission.d = permission.d
      return newPermission
    })

    const formData = {
      org_role: {
        name: values.name,
        org_role_permissions_attributes: orgRolePermissionAttributes
      }
    }

    brandit_rails.post('/admin/organization/org_roles', formData)
  }

  const handlePermissionsChange = (crudType, groupId, value) => {
    const newPermissions = { ...permissionsRef.current }
    if (!newPermissions[groupId]) {
      newPermissions[groupId] = {}
    }
    newPermissions[groupId][crudType] = value
    permissionsRef.current = newPermissions
  }

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{}}
      render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit}>
          <Card>
            <CardHeader>
              {/* <CardTitle></CardTitle> */}
              <div
                className="d-flex flex-wrap"
                style={{
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <strong>Create Role</strong>

                <SaveButton
                  type="submit"
                  disabled={submitting || pristine}
                  onSaveAndEdit={handleSubmit}
                  onSaveAndClose={handleSubmit}
                />
              </div>
            </CardHeader>
            <CardBody>
              <Row>
                <Col md="6">
                  <Field name="name" component={renderInput} label="Role Name" />
                </Col>
                <Col md="6">
                  <Field name="description" component={renderInput} label="Description" />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <OrgPermissionsGrid onPermissionsChange={handlePermissionsChange} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </form>
      )}
    />
  )
}

export default OrgRoleCreate
